import React, { useState, useRef } from "react";

const SuccessKyc = () => {
  return (
    <div
      className=" mb-3 p-5 bg-body rounded shadow-sm mx-auto text-center"
      style={{ maxWidth: 800 }}
    >
      <i
        className="far fa-check-circle"
        style={{ fontSize: 50, marginBottom: 20, color: "#76BC21" }}
      />
      <h3 style={{ color: "#5D50BB" }}>Successfully Submitted</h3>
      <div>
        Your request was submitted successfully, <br />
        Team will connect back with in 3 days
        <br />
        <br />
        <button
          onClick={() => {
            window.location.assign("https://www.greenmanopen.com/");
          }}
          className="btn btn-primary"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessKyc;
